export default "__VITE_ASSET__FaTwJ7NX__"